import React, { 
    useRef, 
    useState, 
    useEffect, 
} from "react"

import {
    Accordion,
    Card,
    InputGroup,
    Form,
    Button,
} from "react-bootstrap"

import "./style.css"

const EMETLContextMenu = (props) => {
    const { 
        xPos, 
        yPos, 
        name, 
        onCloseMenu, 
        unit, 
        actions, 
    } = props    

    const calculatedXPos = xPos
    const calculatedYPos = yPos
    const [xNudge, setXNudge] = useState(0)
    const [yNudge, setYNudge] = useState(0)
    const [activeKey, setActiveKey] = useState(null) // Add state to control accordion
    const ref = useRef(null)
    let isEditingText = false

    const setIsEditingText = (isEditing: boolean) => {
        isEditingText = isEditing
    }
    
    useEffect(()=>{
        setYNudge(ref.current.parentElement.getBoundingClientRect().y)
        setXNudge(ref.current.parentElement.getBoundingClientRect().x)
    }, [])

    return (
        <div
            style={{
                top: `${calculatedYPos - yNudge}px`,
                left: `${calculatedXPos - xNudge}px`,
            }}
            ref={ref}
            className="rounded"
            id="contextMenu"
            onMouseLeave={() => {
                !isEditingText && onCloseMenu()
            }}
        >
            <Accordion 
                activeKey={activeKey} 
                onSelect={setActiveKey}>
                <InputMenuEditor 
                    eventKey="0"
                    noToggle
                    onSubmit={() => {
                        const {
                            addPersonnel,
                        } = actions({
                            unit,
                        })
                        addPersonnel()
                    }}
                    initialvalue={name}
                    title="Add/Edit Members" 
                    actionTitle="Add" 
                />
                <InputMenuEditor 
                    eventKey="1"
                    noToggle
                    onSubmit={() => {
                        const {
                            transferUnit,
                        } = actions(
                            unit,
                        )
                        transferUnit()
                    }}
                    initialvalue={name}
                    title="Transfer Unit" 
                    actionTitle="Transfer" 
                />
                <InputMenuEditor 
                    eventKey="3"
                    noToggle
                    onSubmit={() => {
                        const {
                            deleteUnit,
                        } = actions({
                            unitID: unit.unitID,
                            unit,
                        })
                        deleteUnit()
                    }}
                    title="Delete" 
                    actionTitle="Delete" 
                />
                <InputMenuEditor 
                    eventKey="2"
                    onSubmit={(e) => {
                        const {
                            renameUnit,
                        } = actions({
                            unitID: unit.unitID,
                            unitName: e,
                            unit,
                        })
                        renameUnit()
                        setActiveKey(null) // Close after submit
                        setIsEditingText(false)
                        onCloseMenu()
                    }}
                    initialvalue={name}
                    title="Rename" 
                    actionTitle="Rename" 
                    setIsEditingText={setIsEditingText}
                />
                <InputMenuEditor 
                    eventKey="3"
                    onSubmit={(e) => {
                        const {
                            addUnit,
                        } = actions({
                            unitName: e,
                            unitID: unit.unitID,
                            unit,
                        })
                        addUnit()
                        setIsEditingText(false)
                        setActiveKey(null) // Close after submit
                    }}
                    initialvalue=""
                    title="Add Subunit" 
                    actionTitle="Add Subunit" 
                    setIsEditingText={setIsEditingText}
                />
            </Accordion>
        </div>
    )
}

const InputMenuEditor = (props) => {
    const { 
        onSubmit: doParentSubmit, 
        actionTitle, 
        title, 
        initialvalue, 
        eventKey,
        setIsEditingText = (_: boolean) => {}, 
        noToggle, 
    } = props

    const [inputValue, setValue] = useState(initialvalue || "")
    
    const onInputChange = ({ target: { value } }) => {
        console.log(value, initialvalue)
        if (value === initialvalue)
            setIsEditingText(false)
        else
            setIsEditingText(!!value)

        setValue(value)
    }
    const onSubmit = () => doParentSubmit(inputValue)

    return (
        <Card 
            className="mb-1" 
            style={{
                boxShadow: "none",
                border: "none",
            }}
        >
            {noToggle ? (
                <Card.Header 
                    style={{
                        backgroundColor: "white",
                        cursor: "pointer",
                        border: 0,
                    }}
                    onClick={onSubmit}
                >
                    {title}
                </Card.Header>
            ) : (
                <>

                    <Accordion>
                        <Accordion.Item 
                            eventKey="0"
                            style={{ border: 0 }}
                        >
                            <Accordion.Header 
                                as={Card.Text} 
                                style={{
                                    backgroundColor: "white",
                                    cursor: "pointer",
                                    border: 0,
                                }}
                            >
                                {title}
                            </Accordion.Header>
                            <Accordion.Body>
                                <Card.Body>
                                    <InputGroup 
                                        className="mb-3"
                                    >
                                        <Form.Control 
                                            onChange={onInputChange} 
                                            placeholder={initialvalue} 
                                            value={inputValue}
                                        />
                                        <Button 
                                            variant="outline-secondary"
                                            onClick={onSubmit}
                                        >
                                            {actionTitle}
                                        </Button>
                                    </InputGroup>
                                </Card.Body>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </>
            )}
        </Card>
    )
}

export default EMETLContextMenu